<template>
    <SecondaryPage :showLangSwitchBtn="false">
        <div class="max-w-sm m-auto px-4">
            <div class="text-18 text-a-brown-502314 font-bold text-center mt-6">
                <span v-if="state == 'password'">Please setup PIN</span>
                <span v-else>Comfirm PIN</span>
            </div>
            <div class="mt-3">
                <img class="w-8 m-auto" src="../../../assets/password/ic-lock.svg">
            </div>
            <div class="mt-3 text-a-brown-502314 text-14 text-center">
                This esnsure only you can access your account.
            </div>
            <InputPin
                    ref="input-pin"
                    v-model:inputValue="inputText"
            ></InputPin>
           <div class="max-w-255px m-auto mt-8">
                <RedButton @click="onClickSubmit()">Submit</RedButton>
           </div>
        </div>
    </SecondaryPage>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import CacheHelper from '@/helper/CacheHelper';
import { CacheKey } from '@/helper/StaticValue';
//component
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import InputPin from '@/components/Input/simple/InputPin.vue'
import RedButton from '@/components/Button/RedButton.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//service
import { OtpModel } from '@/core/Account/model/OtpModel';
import { ChangePasswordPinModel } from '../model/AccountLoginModel';
import LoginAccountApi from '../service/LoginAccountApi';
import { AuthLoginConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import BzbsAuth from '@/core/Account/service/BzbsAuth';

export default {
    mixins: [ModalMixin],
    components: {
        SecondaryPage,
        InputPin,
        RedButton,
    },
    data: function () {
        return {
            inputText: '',
            password: '',
            confirmPassword: '',
            otpModel: new OtpModel(),

            state: 'password', // password, confirmPassword
            pathAfterLogin: null,
        };
    },
    created: function () {
        this.setCacheOtp();
        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }
    },
    methods: {
        setCacheOtp: function () {
            let cache = new CacheHelper('session');
            let data = cache.getCache(CacheKey.setPasswordOtp);

            if (data != null) {
                this.otpModel.setFromModel(data);
            }

            Util.log('otp', this.otpModel);
        },

        onClickSubmit: function () {
            if (this.state == 'password') {
                this.submitPassword();
            } else {
                this.submitConfirmPassword();
            }
        },

        submitPassword: function () {
            this.password = this.inputText;
            if (this.password.length != 6) {
                return;
            }

            this.$refs['input-pin'].clearInput();
            this.state = 'confirmPassword';
        },
        submitConfirmPassword: async function () {
            this.confirmPassword = this.inputText;
            if (this.confirmPassword.length != 6) {
                return;
            }

            if (this.password != this.confirmPassword) {
                this.modal.alertModal
                    .clearModal()
                    .setMsg('Password not match')
                    .show();
                this.$refs['input-pin'].clearInput();
                this.state = 'password';
                return;
            }

            this.modal.loadingModal.show();

            let rsSetPassword = await this.apiSetPassword();
            if (!rsSetPassword) {
                this.modal.loadingModal.hide();
                return;
            }

            let accountStatus = await this.checkAccountPasswordStatus();
            if (accountStatus == null) {
                this.modal.loadingModal.hide();
                return;
            }

            let rsLogin = await this.apiLogin(accountStatus.username, this.password);
            this.modal.loadingModal.hide();
            if (!rsLogin) {
                return;
            }

            this.clearCacheSetPassword();
            this.afterLoginRedirect();
        },

        apiSetPassword: function () {
            return new Promise((resolve) => {
                let data = new ChangePasswordPinModel();
                data.setContactNumber(this.otpModel.contactNumber);
                data.setRefcode(this.otpModel.refcode);
                data.setPassword(this.password);
                data.setConfirmPassword(this.confirmPassword);
                let params = data.getParams();

                LoginAccountApi.changePasswordPin(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },

        checkAccountPasswordStatus: function () {
            return new Promise((resolve) => {
                LoginAccountApi.checkAccountLoginStatus(this.otpModel.contactNumber).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(null);
                        this.errorApi(err);
                    },
                });
            });
        },

        apiLogin: function (username, password) {
            return new Promise((resolve) => {
                let loginParams = new AuthLoginConfigBuilder()
                    .setUsername(username)
                    .setPassword(password)
                    .create()
                    .getParams()
                BzbsAuth.apiLogin(loginParams).subscribe({
                    next: (data) => {
                        console.log(data);
                        Account.setLogin(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },

        clearCacheSetPassword: function () {
            let cache = new CacheHelper('session');
            cache.removeCache(CacheKey.setPasswordOtp);
            // let data = cache.getCache(CacheKey.setPasswordOtp);
        },

        afterLoginRedirect: function () {
            if (this.pathAfterLogin == null) {
                window.location.replace('/home');
                // this.$router.replace('/home');
            } else {
                window.location.replace(this.pathAfterLogin);
                // this.$router.replace(this.pathAfterLogin);
            }
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
